import { EventStatusEnum } from "types/EventStatusEnum";

export const eventStatusEnumToLabel = (eventStatus: EventStatusEnum) => {
    switch(eventStatus) {
        case EventStatusEnum.DRAFT: return 'Reserveret';
        case EventStatusEnum.ACTIVE: return 'Bekræftet';
        case EventStatusEnum.CANCELLED: return 'Annulleret';
        default: return '-'
    }
}